import React, {useEffect} from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { passOauthCallback } from '../../api/auth';

const OAuthSignIn = (props) => {
  const { setLoggedIn } = props
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [running, setRunning] = React.useState(false); // eslint-disable-line no-unused-vars

  useEffect(() => {
    if (running) return;
    
    passOauthCallback(searchParams).then((r) => {
      console.log("Backend response for callback ok: ", r);
      setLoggedIn();
      navigate('/');
    }).catch((r) => {
      console.log("Backend response for callback error: ", r);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="mainContainer">
      <div className="titleContainer">
        <div>Finishing login</div>
      </div>
    </div>
  )
}

export default OAuthSignIn
